"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var contentdetail = require("./src/contentdetail");
contentdetail.load();
